import {Injectable} from '@angular/core';
import {
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {TisaMediaLibraryHttpService} from '../tisa-media-library-http.service';

export interface CreateSubdirectoryPayload {
  type: 'file';
  directory: string | null;
  subdirectory_name: string;
}

@Injectable()
export class SubdirectoryService {
  constructor(readonly http: TisaMediaLibraryHttpService) {}

  create(
    stuff: CreateSubdirectoryPayload,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<any>> {
    return this.http
      .post('/files/create_subdirectory', serialize({stuff}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
